import initLanguageSwitcher from "./language-switcher";
import initNavigation from "./navigation";

initLanguageSwitcher();
initNavigation();
